import { render, staticRenderFns } from "./hzxxTJNoVideo.vue?vue&type=template&id=15a14c2f&scoped=true"
import script from "./hzxxTJNoVideo.vue?vue&type=script&lang=js"
export * from "./hzxxTJNoVideo.vue?vue&type=script&lang=js"
import style0 from "./hzxxTJNoVideo.vue?vue&type=style&index=0&id=15a14c2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a14c2f",
  null
  
)

export default component.exports